module.exports = __webpack_public_path__ + "media/images/roadpass_inline_logo-8eb911bda76ebc0cfe18034ff6169938.png";